module.exports = __webpack_public_path__ + "media/checkout/vipTime-77f4f87d.svg";